import { useRouter } from "next/dist/client/router";
import { memo, useCallback } from "react";
import { useRecoilState } from "recoil";
import { TicketStatusJp } from "../../../entities/Ticket";
import { FieldType } from "../../../entities/TicketField";
import { useShopAgents } from "../../../hooks/agentHooks";
import { hmDisplay, toDate, ymdDisplayJp, ymdhmDisplayJp } from "../../../lib/datetime";
import tabListState from "../../../state/tabListState";
import ticketSelectState, { TICKET_SELECT_KEYS } from "../../../state/ticketSelectState";
import useAuthContext from "../../context/AuthContext";

const DefaultTicketListRow = memo(({ ticket, unit, ticketFields }:{ ticket, unit, ticketFields }) => {

  const router = useRouter();
  const [tabList, setTabList] = useRecoilState(tabListState);
  const [selectState, setSelectState] = useRecoilState(ticketSelectState)
  const isSelected = selectState[TICKET_SELECT_KEYS.assign]?.includes(ticket?.id)
  const {currentShop} = useAuthContext()
  const [agents, setAgents] = useShopAgents(currentShop?.id)
  const onClick = useCallback(() => {
    const tab = tabList.pages.find((_tab) => _tab.id == ticket.id);
    const pages = [...tabList.pages, {
      id: ticket.id,
      name: ticket.title,
      type: 'ticket',
      route: ticket.ticketRoute
    }]
    const currentIndex = pages.findIndex((page) => page.id == ticket.id)

    if (!tab) {
      setTabList({
        ...tabList,
        pages: pages,
        current: currentIndex
      })
    } else {
      setTabList({
        ...tabList,
        current: currentIndex
      })
    }
    router.push(`/tickets/${ticket?.id}`)
  },[router, ticket.id])

  const onClickSelect = (e) => {
    e.stopPropagation();
    e.preventDefault();

    setSelectState({
      ...selectState,
      [TICKET_SELECT_KEYS.assign]: isSelected ?
        selectState[TICKET_SELECT_KEYS.assign]?.filter((v) => v != ticket.id) :
        Array.from(new Set([...selectState[TICKET_SELECT_KEYS.assign], ticket.id]))
    })
  }

  return (<tr key={ticket.id}
    className="cursor-pointer border-b box-border border-separate first:border-t border-gray-300"
    onClick={onClick}>
      <td
      className="p-4 text-center text-xl break-words whitespace-pre-wrap"
      onClick={onClickSelect}
      >
        {isSelected}
        <label htmlFor="selectTicket" className={`check-label ${isSelected && "before:border-gray-500 after:opacity-100"}`}></label>
        <input id="selectTicket" className={`hidden`} type="checkbox" />
      </td>
      { unit?.visibleFieldCodes?.map((code) => {
        const field = ticketFields?.find((field) => field.code == code)
        const agent = agents.find((_agent) => ticket.agent && _agent.id == ticket.agent)
        return (<td key={code} className="p-3 text-center text-lg whitespace-pre-wrap break-words">
          {(field?.type == "Date") &&
            ymdDisplayJp(toDate(ticket[code]))
          }
          {(field?.type == "Time") &&
            hmDisplay(toDate(ticket[code]))
          }
          {(field?.type == "Datetime") &&
            ymdhmDisplayJp(toDate(ticket[code]))
          }
          {(code == 'ticketStatus') &&
            TicketStatusJp[ticket[code]]
          }
          {code == 'agent' &&
            (agent?.name || agent?.email)
          }
          {(field?.type == FieldType.Boolean) &&
            (ticket[code]?.includes('checked') ? 'チェック済' : '未チェック')
          }
          {(code != 'ticketStatus' && code != 'agent')
            && !(field?.type == "Date" || field?.type == "Datetime" || field?.type == "Time")
            && (field?.type != FieldType.Boolean)
            && ticket[code]?.toString()
          }
        </td>)
      })}
  </tr>)
})

export default DefaultTicketListRow;